import { defaultTo, pipe, replace, toUpper } from 'ramda'

const capitalize = pipe(
  defaultTo(''),
  replace(/^./, toUpper)
)

export default capitalize
